export default __webpack_public_path__ + "static/media/gallery16.5674b67b.jpg";